var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module",class:_vm.loading ? 'module--loading' : ''},[_c('div',{staticClass:"module__media bg-dark-pink"}),_vm._m(0),_c('div',{staticClass:"module__main"},[_c('fieldset',[_c('cludo-vue-input',{staticClass:"form-control form-control--search",attrs:{"placeholder":"Search..."}},[_c('span',{staticClass:"sr-only"},[_vm._v("Search")]),_c('i',{staticClass:"icon-search",attrs:{"aria-hidden":"true"}})])],1),_c('button',{staticClass:"button button--small button--block button--toggle toggle toggle--m",attrs:{"type":"button","aria-expanded":"false","aria-controls":"search-filters","data-toggle":"true"}},[_vm._v(" Filter courses "),(_vm.isFiltering)?_c('span',{staticClass:"badge bg-white"},[_vm._v(_vm._s(_vm.filtersCount))]):_vm._e()]),_c('div',{staticClass:"collapse collapse--tablet-expanded",attrs:{"id":"search-filters"}},[_c('div',{staticClass:"collapse__content"},[_c('cludo-vue-check-boxes',{attrs:{"options":[
              {
                label: 'Taught',
                name: 'taught',
                field: 'StudyType',
                value: 'Taught',
              },
              {
                label: 'Research',
                name: 'research',
                field: 'StudyType',
                value: 'Research',
              },
            ]}},[_c('div',{staticClass:"filter-heading"},[_c('legend',[_vm._v("Study type")])])]),_c('cludo-vue-check-boxes',{attrs:{"options":[
            {
              label: 'Full-time study',
              name: 'full-time',
              field: 'StudyModes',
              value:
                'Full-time, Full-time&#44; Part-time'
            },
            {
              label: 'Part-time study',
              name: 'part-time',
              field: 'StudyModes',
              value:
                'Part-time, Full-time&#44; Part-time'
            },
          ]}},[_c('div',{staticClass:"filter-heading"},[_c('legend',[_vm._v("Mode of study ")])])]),_c('cludo-vue-check-boxes',{attrs:{"options":[
              {
                label: 'On campus',
                name: 'on-campus',
                field: 'StudyDeliveryMethod',
                value:
                  'on-campus, on-campus & online-learning, on-campus & online-with-on-campus-learning, on-campus & distance-learning',
              },
              {
                label: 'Online',
                name: 'online-learning',
                field: 'StudyDeliveryMethod',
                value:
                  'online-learning,on-campus & online-learning,online-learning & online-with-on-campus-learning,online-learning & distance-learning',
              },
              {
                label: 'Online with on campus elements',
                name: 'online-with-on-campus-learning',
                field: 'StudyDeliveryMethod',
                value:
                  'online-with-on-campus-learning,on-campus & online-with-on-campus-learning,online-learning & online-with-on-campus-learning,online-with-on-campus-learning & distance-learning',
              },
              {
                label: 'Distance learning',
                name: 'distance-learning',
                field: 'StudyDeliveryMethod',
                value:
                  'distance-learning,on-campus & distance-learning,online-learning & distance-learning,online-with-on-campus-learning & distance-learning',
              },
            ]}},[_c('div',{staticClass:"filter-heading"},[_c('legend',[_vm._v("Delivery method")])])]),_c('cludo-vue-check-boxes',{attrs:{"options":_vm.subjectOptions}},[_c('div',{staticClass:"filter-heading"},[_c('legend',[_vm._v("Subject")])])]),_c('cludo-vue-check-boxes',{attrs:{"options":[
              {
                label: 'Arts, Law and Social Sciences',
                name: 'arts law and social sciences',
                field: 'Faculty',
                value: 'Arts Law and Social Sciences',
              },
              {
                label: 'Health and Life Sciences',
                name: 'health and life sciences',
                field: 'Faculty',
                value: 'Health and Life Sciences',
              },
              {
                label: 'Science and Engineering',
                name: 'science and engineering',
                field: 'Faculty',
                value: 'Science and Engineering',
              },
            ]}},[_c('div',{staticClass:"filter-heading"},[_c('legend',[_vm._v("Faculty")])])])],1)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module__header"},[_c('h2',[_vm._v("Search by programme name or keyword")])])
}]

export { render, staticRenderFns }